import type { ReactNode } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

interface ConfirmationDialogProps {
  open: boolean;
  titre?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onClose: (userChoice: "confirm" | "cancel") => void;
}

function ConfirmationDialog({
  open,
  onClose,
  titre = "Confirmation",
  confirmLabel,
  cancelLabel,
  description = "Êtes vous sûr(e) de vouloir réaliser cette opération ?",
}: Readonly<ConfirmationDialogProps>): ReactNode {
  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose("cancel");
      }}>
      <DialogTitle>{titre}</DialogTitle>
      <DialogContent>
        <Typography>{description}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose("cancel");
          }}
          color="error">
          {cancelLabel ?? "Annuler"}
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            onClose("confirm");
          }}>
          {confirmLabel ?? "Confirmer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
